import { ApplicationController } from 'stimulus-use'

export default class extends ApplicationController {

    go() {
        this.element.submit()
    }

}